import types from "./mutation-types";
/* eslint-disable no-param-reassign */
export default {
  [types.SET_IS_TOTAL_GENERATING_IN_PROCESS]: (state, status) => {
    state.isTotalGeneratingInProcess = !!status;
  },
};
